import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { getCloudMarketplaceAppByKey } from '@atlassian/mpac-api-client';
import { makeInstalledAppFromSPIInstalledApp, makeMarketplaceAppDisplayDetailsFromMarketplaceApp } from '@atlassian/mpac-spi';
import { Option } from 'funfix-core';
import { List } from 'immutable';
import { defaultContextName } from '../records/Context';
import { makeFlag, SUCCESS_APPEARANCE } from '../records/Flag';
import { makePaginatedValues } from '../records/PaginatedValues';
import getSPI from '../services/SPI';
import { resolveFieldWithFallback } from '../utils/common-utils';
import { getRequestId } from '../utils/request-utils';
import { addCaasErrorFlag, addFlag } from './Flags';
export const APPS_PER_PAGE = 20;
export const FETCH_FRESH_INSTALLED_APPS = 'INSTALLED_APPS_FETCH_FRESH_INSTALLED_APPS';
export const RECEIVE_FRESH_INSTALLED_APPS = 'INSTALLED_APPS_RECEIVE_FRESH_INSTALLED_APPS';
export const RECEIVE_FRESH_INSTALLED_APPS_ERROR = 'INSTALLED_APPS_RECEIVE_FRESH_INSTALLED_APPS_ERROR';
export const FETCH_MORE_GLOBALLY_INSTALLED_APPS = 'INSTALLED_APPS_FETCH_MORE_GLOBALLY_INSTALLED_APPS';
export const RECEIVE_MORE_GLOBALLY_INSTALLED_APPS = 'INSTALLED_APPS_RECEIVE_MORE_GLOBALLY_INSTALLED_APPS';
export const RECEIVE_MORE_GLOBALLY_INSTALLED_APPS_ERROR = 'INSTALLED_APPS_RECEIVE_MORE_GLOBALLY_INSTALLED_APPS_ERROR';
export const FETCH_MORE_LOCALLY_INSTALLED_APPS = 'INSTALLED_APPS_FETCH_MORE_LOCALLY_INSTALLED_APPS';
export const RECEIVE_MORE_LOCALLY_INSTALLED_APPS = 'INSTALLED_APPS_RECEIVE_MORE_LOCALLY_INSTALLED_APPS';
export const RECEIVE_MORE_LOCALLY_INSTALLED_APPS_ERROR = 'INSTALLED_APPS_RECEIVE_MORE_LOCALLY_INSTALLED_APPS_ERROR';
export const START_UNINSTALL_APP_FROM_LOCAL_CONTEXT = 'INSTALLED_APPS_START_UNINSTALL_APP_FROM_LOCAL_CONTEXT';
export const FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT = 'INSTALLED_APPS_FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT';
export const UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR = 'INSTALLED_APPS_UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR';
export const START_UNINSTALL_APP_FROM_SITE = 'INSTALLED_APPS_START_UNINSTALL_APP_FROM_SITE';
export const FINISH_UNINSTALL_APP_FROM_SITE = 'INSTALLED_APPS_FINISH_UNINSTALL_APP_FROM_SITE';
export const UNINSTALL_APP_FROM_SITE_ERROR = 'INSTALLED_APPS_UNINSTALL_APP_FROM_SITE_ERROR';
export const START_REVOKE_USER_GRANT_GLOBALLY = 'INSTALLED_APPS_START_REVOKE_USER_GRANT_GLOBALLY';
export const FINISH_REVOKE_USER_GRANT_GLOBALLY = 'INSTALLED_APPS_FINISH_REVOKE_USER_GRANT_GLOBALLY';
export const REVOKE_USER_GRANT_GLOBALLY_ERROR = 'INSTALLED_APPS_REVOKE_USER_GRANT_GLOBALLY_ERROR';
export const OPEN_SITE_UNINSTALL_DIALOG = 'INSTALLATION_OPEN_SITE_UNINSTALL_DIALOG';
export const CLOSE_SITE_UNINSTALL_DIALOG = 'INSTALLATION_CLOSE_SITE_UNINSTALL_DIALOG';
export const FINISH_FETCH_MARKETPLACE_APP_DETAILS = 'FINISH_FETCH_MARKETPLACE_APP_DETAILS';
function fetchFreshInstalledApps(_ref) {
  let {
    requestId,
    search
  } = _ref;
  return {
    type: FETCH_FRESH_INSTALLED_APPS,
    requestId,
    search
  };
}
function receiveFreshInstalledApps(_ref2) {
  let {
    requestId,
    globallyInstalledAppsPage,
    locallyInstalledAppsPage
  } = _ref2;
  return {
    type: RECEIVE_FRESH_INSTALLED_APPS,
    requestId,
    globallyInstalledAppsPage,
    locallyInstalledAppsPage
  };
}
function receiveFreshInstalledAppsError(_ref3) {
  let {
    requestId,
    dataErrorMessages
  } = _ref3;
  return {
    type: RECEIVE_FRESH_INSTALLED_APPS_ERROR,
    requestId,
    dataErrorMessages
  };
}
function fetchMoreGloballyInstalledApps(_ref4) {
  let {
    requestId,
    offset
  } = _ref4;
  return {
    type: FETCH_MORE_GLOBALLY_INSTALLED_APPS,
    requestId,
    offset
  };
}
function receiveMoreGloballyInstalledApps(_ref5) {
  let {
    requestId,
    installedAppsPage
  } = _ref5;
  return {
    type: RECEIVE_MORE_GLOBALLY_INSTALLED_APPS,
    requestId,
    globallyInstalledAppsPage: installedAppsPage
  };
}
function receiveMoreGloballyInstalledAppsError(_ref6) {
  let {
    requestId,
    dataErrorMessages
  } = _ref6;
  return {
    type: RECEIVE_MORE_GLOBALLY_INSTALLED_APPS_ERROR,
    requestId,
    dataErrorMessages
  };
}
function fetchMoreLocallyInstalledApps(_ref7) {
  let {
    requestId,
    offset
  } = _ref7;
  return {
    type: FETCH_MORE_LOCALLY_INSTALLED_APPS,
    requestId,
    offset
  };
}
function receiveMoreLocallyInstalledApps(_ref8) {
  let {
    requestId,
    installedAppsPage
  } = _ref8;
  return {
    type: RECEIVE_MORE_LOCALLY_INSTALLED_APPS,
    requestId,
    locallyInstalledAppsPage: installedAppsPage
  };
}
function receiveMoreLocallyInstalledAppsError(_ref9) {
  let {
    requestId,
    dataErrorMessages
  } = _ref9;
  return {
    type: RECEIVE_MORE_LOCALLY_INSTALLED_APPS_ERROR,
    requestId,
    dataErrorMessages
  };
}
function startUninstallAppFromLocalContext(_ref10) {
  let {
    installedApp
  } = _ref10;
  return {
    type: START_UNINSTALL_APP_FROM_LOCAL_CONTEXT,
    installedApp
  };
}
function finishUninstallAppFromLocalContext(_ref11) {
  let {
    installedApp,
    context
  } = _ref11;
  return {
    type: FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT,
    installedApp,
    context
  };
}
function uninstallAppFromLocalContextError(_ref12) {
  let {
    installedApp,
    context,
    message
  } = _ref12;
  return {
    type: UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR,
    installedApp,
    context,
    message
  };
}
function startUninstallAppFromSite(_ref13) {
  let {
    installedApp
  } = _ref13;
  return {
    type: START_UNINSTALL_APP_FROM_SITE,
    installedApp
  };
}
function finishUninstallAppFromSite(_ref14) {
  let {
    installedApp,
    context
  } = _ref14;
  return {
    type: FINISH_UNINSTALL_APP_FROM_SITE,
    installedApp,
    context
  };
}
function uninstallAppFromSiteError(_ref15) {
  let {
    installedApp,
    context,
    message
  } = _ref15;
  return {
    type: UNINSTALL_APP_FROM_SITE_ERROR,
    installedApp,
    context,
    message
  };
}
function startRevokeUserGrantGlobally(_ref16) {
  let {
    installedApp,
    userGrant
  } = _ref16;
  return {
    type: START_REVOKE_USER_GRANT_GLOBALLY,
    installedApp,
    userGrant
  };
}
function finishRevokeUserGrantGlobally(_ref17) {
  let {
    installedApp,
    userGrant
  } = _ref17;
  return {
    type: FINISH_REVOKE_USER_GRANT_GLOBALLY,
    installedApp,
    userGrant
  };
}
function revokeUserGrantGloballyError(_ref18) {
  let {
    installedApp,
    userGrant,
    message
  } = _ref18;
  return {
    type: REVOKE_USER_GRANT_GLOBALLY_ERROR,
    installedApp,
    userGrant,
    message
  };
}
export function openSiteUninstallDialog(_ref19) {
  let {
    installedApp
  } = _ref19;
  return {
    type: OPEN_SITE_UNINSTALL_DIALOG,
    installedApp
  };
}
export function closeSiteUninstallDialog(_ref20) {
  let {
    installedApp
  } = _ref20;
  return {
    type: CLOSE_SITE_UNINSTALL_DIALOG,
    installedApp
  };
}
const finishFetchMarketplaceAppDetails = _ref21 => {
  let {
    marketplaceAppDetails,
    isGlobalContext
  } = _ref21;
  return {
    type: FINISH_FETCH_MARKETPLACE_APP_DETAILS,
    marketplaceAppDetails,
    isGlobalContext
  };
};
function getInstalledApps(_ref22) {
  let {
    contextId,
    search,
    offset,
    flags
  } = _ref22;
  const query = {
    search: search || '',
    offset,
    limit: APPS_PER_PAGE
  };
  const options = flags ? {
    contextId,
    query,
    flags
  } : {
    contextId,
    query
  };
  return getSPI().getInstalledAddons(options).then(paginatedAddons => makePaginatedValues({
    values: List(paginatedAddons.values).map(makeInstalledAppFromSPIInstalledApp),
    nextOffset: Option.of(paginatedAddons.nextOffset),
    totalCount: paginatedAddons.totalCount
  }));
}
const resolveGlobalContextIdFromLocal = _ref23 => {
  let {
    localContext
  } = _ref23;
  return localContext.id.substring(0, localContext.id.indexOf('/') + 1);
};
export function doRetrieveFreshInstalledApps(_ref24) {
  let {
    hostConfig,
    context,
    search,
    flags
  } = _ref24;
  return dispatch => {
    const requestId = getRequestId();
    dispatch(fetchFreshInstalledApps({
      requestId,
      search
    }));
    const installedAppsPromises = [getInstalledApps({
      contextId: context.id,
      search,
      offset: 0,
      flags
    })];
    const globalContextId = resolveGlobalContextIdFromLocal({
      localContext: context
    });
    if (globalContextId !== context.id) {
      installedAppsPromises.push(getInstalledApps({
        contextId: globalContextId,
        search,
        offset: 0,
        flags
      }));
    }
    Promise.all(installedAppsPromises).then(_ref25 => {
      let [locallyInstalledAppsPage, globalInstalledApps] = _ref25;
      const globallyInstalledAppsPage = globalInstalledApps || makePaginatedValues();
      dispatch(receiveFreshInstalledApps({
        requestId,
        search,
        locallyInstalledAppsPage,
        globallyInstalledAppsPage
      }));
    }, error => {
      dispatch(receiveFreshInstalledAppsError({
        requestId,
        dataErrorMessages: makeDataErrorMessages([error])
      }));
      dispatch(addCaasErrorFlag({
        message: error,
        key: "fetch-fresh-apps-error-".concat(context.id),
        hostConfig
      }));
      console.error('getInstalledAddons call for freshInstalledApps was rejected by the SPI and returned the following message:', error);
    });
  };
}
function retrieveMoreInstalledAppsFactory(_ref26) {
  let {
    retrieveMoreInstalledApps,
    receiveMoreInstalledApps,
    retrieveMoreInstalledAppsError
  } = _ref26;
  return _ref27 => {
    let {
      contextId,
      hostConfig,
      search,
      offset
    } = _ref27;
    return dispatch => {
      const requestId = getRequestId();
      dispatch(retrieveMoreInstalledApps({
        requestId,
        offset
      }));
      getInstalledApps({
        contextId,
        search,
        offset
      }).then(installedAppsPage => {
        dispatch(receiveMoreInstalledApps({
          requestId,
          installedAppsPage
        }));
      }, error => {
        dispatch(retrieveMoreInstalledAppsError({
          requestId,
          dataErrorMessages: makeDataErrorMessages([error])
        }));
        dispatch(addCaasErrorFlag({
          message: error,
          key: "fetch-more-apps-error-".concat(contextId),
          hostConfig
        }));
        console.error('getInstalledAddons call for moreInstalledApps was rejected by the SPI and returned the following message:', error);
      });
    };
  };
}
const retrieveLocallyInstalledApps = retrieveMoreInstalledAppsFactory({
  receiveMoreInstalledApps: receiveMoreLocallyInstalledApps,
  retrieveMoreInstalledApps: fetchMoreLocallyInstalledApps,
  retrieveMoreInstalledAppsError: receiveMoreLocallyInstalledAppsError
});
export const doRetrieveMoreLocallyInstalledApps = _ref28 => {
  let {
    hostConfig,
    context,
    search,
    offset = 0
  } = _ref28;
  return retrieveLocallyInstalledApps({
    contextId: context.id,
    hostConfig,
    search,
    offset
  });
};
const retrieveGloballyInstalledApps = retrieveMoreInstalledAppsFactory({
  receiveMoreInstalledApps: receiveMoreGloballyInstalledApps,
  retrieveMoreInstalledApps: fetchMoreGloballyInstalledApps,
  retrieveMoreInstalledAppsError: receiveMoreGloballyInstalledAppsError
});
export const doRetrieveMoreGloballyInstalledApps = _ref29 => {
  let {
    hostConfig,
    context,
    search,
    offset = 0
  } = _ref29;
  return retrieveGloballyInstalledApps({
    contextId: resolveGlobalContextIdFromLocal({
      localContext: context
    }),
    hostConfig,
    search,
    offset
  });
};
export const doUninstallAppFromLocalContext = _ref30 => {
  let {
    context,
    installedApp,
    hostConfig
  } = _ref30;
  return dispatch => {
    const appKey = installedApp.details.key;
    return new Promise((resolve, reject) => {
      dispatch(startUninstallAppFromLocalContext({
        installedApp
      }));
      getSPI().uninstallAddon({
        addon: installedApp._original,
        contextId: context.id
      }).then(() => {
        dispatch(finishUninstallAppFromLocalContext({
          installedApp,
          context
        }));
        const appName = installedApp.details.name;
        const contextName = context.name || defaultContextName;
        dispatch(addFlag({
          flag: makeFlag({
            key: "".concat(appKey, "-uninstall-from-context-success"),
            title: "".concat(appName, " was removed from ").concat(contextName),
            appearance: SUCCESS_APPEARANCE
          })
        }));
        resolve();
      }, error => {
        dispatch(addCaasErrorFlag({
          message: error,
          key: "uninstall-error-".concat(appKey, "-").concat(context.id),
          hostConfig
        }));
        dispatch(uninstallAppFromLocalContextError({
          installedApp,
          context,
          message: error
        }));
        console.error('uninstallAddon was rejected by the SPI and returned the following message:', error);
        reject();
      });
    });
  };
};
export function doUninstallAppFromSite(_ref31) {
  let {
    installedApp,
    hostConfig,
    context
  } = _ref31;
  return dispatch => {
    const appKey = installedApp.details.key;
    const appName = resolveFieldWithFallback(add => add.name, installedApp.marketplaceAppDetails, installedApp.details);
    const successNotification = hostConfig.removeFromSite.successNotification;
    return new Promise((resolve, reject) => {
      dispatch(startUninstallAppFromSite({
        installedApp
      }));
      getSPI().uninstallAddonFromSite({
        addon: installedApp._original
      }).then(() => {
        dispatch(finishUninstallAppFromSite({
          installedApp,
          context
        }));
        dispatch(addFlag({
          flag: makeFlag({
            key: "".concat(appKey, "-uninstall-from-site-success"),
            title: successNotification(appName),
            appearance: SUCCESS_APPEARANCE
          })
        }));
        resolve();
      }, error => {
        dispatch(addCaasErrorFlag({
          message: error,
          key: "uninstall-error-".concat(appKey),
          hostConfig
        }));
        dispatch(uninstallAppFromSiteError({
          installedApp,
          context,
          message: error
        }));
        reject();
        console.error('uninstallAddonFromSite was rejected by the SPI and returned the following message:', error);
      });
    });
  };
}
export function doRevokeUserGrantGlobally(_ref32) {
  let {
    hostConfig,
    installedApp,
    userGrant
  } = _ref32;
  return dispatch => {
    dispatch(startRevokeUserGrantGlobally({
      installedApp,
      userGrant
    }));
    getSPI().revokeUserGrant({
      addon: installedApp._original,
      user: userGrant.user._original
    }).then(() => {
      dispatch(finishRevokeUserGrantGlobally({
        installedApp,
        userGrant
      }));
      dispatch(addFlag({
        flag: makeFlag({
          key: "".concat(installedApp.details.key, "-revoke-user-grant-success"),
          title: "".concat(resolveFieldWithFallback(add => add.name, installedApp.marketplaceAppDetails, installedApp.details), " was successfully disconnected"),
          appearance: SUCCESS_APPEARANCE
        })
      }));
    }, error => {
      dispatch(addCaasErrorFlag({
        message: error,
        key: "revoke-user-grant-error-".concat(installedApp.details.key),
        hostConfig
      }));
      dispatch(revokeUserGrantGloballyError({
        installedApp,
        userGrant,
        message: error
      }));
      console.error('revokeUserGrant was rejected by the SPI and returned the following message:', error);
    });
  };
}
export const doFetchMarketplaceAppDetails = _ref33 => {
  let {
    mpacBaseUrl,
    appKey,
    isGlobalContext
  } = _ref33;
  return dispatch => getCloudMarketplaceAppByKey(mpacBaseUrl, appKey).then(marketplaceApp => makeMarketplaceAppDisplayDetailsFromMarketplaceApp({
    marketplaceApp,
    mpacBaseUrl
  })).then(marketplaceAppDetails => {
    dispatch(finishFetchMarketplaceAppDetails({
      marketplaceAppDetails,
      isGlobalContext
    }));
    return marketplaceAppDetails;
  }, error => {
    console.warn('Failed to fetch App data from Marketplace.', error);
    return error;
  });
};